import { BankTypeEnum } from '@/interface/KKC/withdrawal';
import moduleStyle from './index.module.less';

export const numBgClassNameMap: {
  [key: number]: string;
} = {
  0: moduleStyle.boc_bg_img,
  1: moduleStyle.citi_bg_img,
  2: moduleStyle.hsbc_bg_img,
  3: moduleStyle.scb_bg_img,
};

export const bankPrimaryColor = {
  [BankTypeEnum.BOC]: '#00C34E',
  [BankTypeEnum.CITI]: '#AE64EF',
  [BankTypeEnum.HSBC]: '#01A3ED',
  [BankTypeEnum.SCB]: '#426EFF',
};

export const numPrimaryColor: {
  [key: number]: string;
} = {
  0: '#00DE59',
  1: '#AE64EF',
  2: '#01A3ED',
  3: '#0003FF',
  4: '#FFB200',
  5: '#FF0C86',
};

export const getHashNum = (code: string | number) => {
  const numCode = Number(code);
  return Math.ceil(numCode) % 6;
};
